// @flow
import * as React from 'react';
import { Link } from 'react-router';
import { Row, Col, Button } from 'react-bootstrap';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { Marker, Target, MagnifyingGlass, Mail } from '../../components/Icons';
import fuzzyFilterFactory from 'react-fuzzy-filter';
import PaginatedList from '../../components/PaginatedList';
import SidebarFilterBox from '../../components/SidebarFilterBox';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

import MomentLocaleUtils, {
  formatDate,
  parseDate
} from 'react-day-picker/moment';

const Icon = props => {
  let icon;
  switch (props.status) {
    default:
    case 1:
      icon = <MagnifyingGlass height="24px" />;
      break;
    case 2:
      icon = <Marker height="32px" />;
      break;
    case 3:
      icon = <Target height="30px" />;
      break;
    case 4:
      icon = <Mail height="30px" />;
  }
  return <div className="icon">{icon}</div>;
};

type Props = {
  params: {
    context: any,
    bookingId: {
      id: string | number
    }
  },
  currentOrgId: any,
  bookings: any,
  getBookings: Function
};

type State = {
  showArchived: boolean,
  filterValue: string,
  startDate: Date,
  endDate: Date,
  datesLoaded: boolean
};

export default class BookingSidebar extends React.Component<Props, State> {
  fuzzyFilterFactory: any;
  screenReaderContent: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      showArchived: false,
      filterValue: '',
      startDate: new Date(),
      endDate: new Date(),
      datesLoaded: false
    };
    this.fuzzyFilterFactory = fuzzyFilterFactory();
  }

  componentDidMount() {
    this.getBookings(this.props, this.props.params.context);
  }

  componentWillReceiveProps(nextProps: Props) {
    // currentOrganisation or currentLocation has changed
    if (
      nextProps.params.context !== 'global' &&
      this.props.currentOrgId !== nextProps.currentOrgId
    ) {
      this.getBookings(nextProps, nextProps.params.context);
    }
    if (
      this.props.bookings !== nextProps.bookings &&
      this.props.bookings.length > 0
    ) {
      if (
        this.props.bookings &&
        this.props.bookings.length > 0 &&
        this.props.bookings[0]
      )
        this.setState({
          endDate: new Date(this.props.bookings[0].dateCreated)
        });
      this.setState({
        startDate: new Date(
          this.props.bookings[this.props.bookings.length - 1].dateCreated
        )
      });
      this.setState({ datesLoaded: true });
    }
  }

  getBookings = (props: Props, context: string) => {
    const organisationId = props.currentOrgId;
    switch (context) {
      case 'global':
        this.props.getBookings();
        break;
      default:
      case 'customer':
      case 'sub-account':
        this.props.getBookings(organisationId);
    }
  };

  updateFilterValue = (filterValue: ?string) => {
    this.setState({ filterValue: filterValue || '' });
  };

  startDateChange = (day: Date) => {
    this.setState({ startDate: day });
  };

  endDateChange = (day: Date) => {
    this.setState({ endDate: day });
  };

  downloadBookings = () => {
    let csvContent = '';
    const headersArray = [];
    const downloadableBookings = [];

    headersArray.push('Booking Ref Number');
    headersArray.push('Download date');
    headersArray.push('Campaign Name');
    headersArray.push('Total number of records downloaded');
    headersArray.push('User Name');
    headersArray.push('Organisation Name');

    downloadableBookings[0] = headersArray;
    for (let i = 0; i < this.props.bookings.length; i++) {
      if (
        new Date(this.props.bookings[i].dateCreated).setHours(0, 0, 0, 0) >=
          new Date(this.state.startDate).setHours(0, 0, 0, 0) &&
        new Date(this.props.bookings[i].dateCreated).setHours(0, 0, 0, 0) <=
          new Date(this.state.endDate).setHours(0, 0, 0, 0)
      ) {
        const tempBookingRowArray = [];
        tempBookingRowArray.push(this.props.bookings[i]['bookingNumber']);
        tempBookingRowArray.push(
          moment(this.props.bookings[i]['dateUpdated']).format('DD/MM/YYYY')
        );
        tempBookingRowArray.push(this.props.bookings[i]['campaignName']);
        tempBookingRowArray.push(
          this.props.bookings[i]['totalNumberOfRecordsSaved']
        );
        tempBookingRowArray.push(this.props.bookings[i]['userName']);
        tempBookingRowArray.push(this.props.bookings[i]['organisationName']);
        downloadableBookings.push(tempBookingRowArray);
      }
    }

    downloadableBookings.forEach(function(downloadableBooking) {
      let row = downloadableBooking.join(',');
      csvContent += row + '\r\n';
    });

    if (!navigator.userAgent.match('CriOS')) {
      const csv = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
      saveAs(csv, 'bookings.csv');
    } else {
      csvContent = `data:text/csv;charset=utf-8,${csvContent}`;
      let encodedUri = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'bookings.csv');
      if (document.body) {
        document.body.appendChild(link);
      }
      link.click();
      if (document.body) {
        document.body.removeChild(link);
      }
    }
  };

  render() {
    const {
      params: { bookingId = 'new', context },
      currentOrgId,
      bookings
    } = this.props;

    const { startDate, endDate, datesLoaded } = this.state;
    const LineItem = props => {
      const booking = props.item;
      return (
        <Row
          key={booking.id}
          className={`sidebar-list-item tall-list-item ${context}`}
        >
          <Link to={`/${context}/${currentOrgId}/bookings/${booking.id}`}>
            <Col
              sm={12}
              className={`overflow-ellipsis map-link ${bookingId &&
                // $FlowFixMe
                bookingId.id &&
                // $FlowFixMe
                bookingId === booking.id.toString() &&
                'active'}`}
            >
              <span className="booking-list-icon">
                <Icon status={0} />
              </span>
              <p title={booking.bookingNumber}>
                <strong>{booking.bookingNumber}</strong>
                {context === 'global' && <p>{booking.organisationName}</p>}
              </p>
              <div>
                <small
                  title={`Date Created ${moment(booking.dateCreated).format(
                    'DD/MM/YYYY'
                  )}`}
                >
                  Date Created{' '}
                  {moment(booking.dateCreated).format('DD/MM/YYYY')}
                </small>
              </div>
              <div>
                <small
                  title={`Updated ${moment(booking.dateUpdated).format(
                    'DD/MM/YYYY'
                  )}`}
                >
                  Updated at {moment(booking.dateUpdated).format('DD/MM/YYYY')}
                </small>
              </div>
            </Col>
          </Link>
        </Row>
      );
    };

    return (
      <div className="generic-sidebar">
        <Row>
          <Col sm={12} md={6}>
            <h3
              className="screen-reader-only"
              tabIndex="-1"
              ref={i => (this.screenReaderContent = i)}
            >
              Bookings
            </h3>
            <h1>Bookings</h1>
          </Col>
          <Col sm={12} md={12} lg={12}>
            <SidebarFilterBox
              onChange={this.updateFilterValue}
              fuzzyFilterFactory={this.fuzzyFilterFactory}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {bookings && (
              <PaginatedList
                filterValue={this.state.filterValue}
                itemsPerPage={10}
                component={LineItem}
                pageButtonLimit={5}
                items={bookings.sort(
                  (a, b) => new Date(b.dateUpdated) - new Date(a.dateUpdated)
                )}
                showArchived={this.state.showArchived}
                fuzzyFilterFactory={this.fuzzyFilterFactory}
                keys={['dateUpdated', 'bookingNumber', 'organisationName']}
                pluralName="bookings"
                sortOrder="desc"
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={12} lg={12} className="show-archived-wrapper">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                name="archiveCheckbox"
                id="archiveCheckbox"
                className="archive-checkbox"
                checked={this.state.showArchived}
                onChange={() =>
                  this.setState({ showArchived: !this.state.showArchived })
                }
              />
              <label htmlFor="archiveCheckbox" className="checkbox-label">
                Show Archived
              </label>
            </div>
          </Col>
        </Row>
        {context === 'global' && datesLoaded && (
          <Row className="booking-download">
            <Col xs={12}>
              <h1>Download Bookings</h1>
            </Col>
            <Col xs={6}>
              <DayPickerInput
                formatDate={formatDate}
                parseDate={parseDate}
                inputProps={{ className: 'form-control' }}
                value={startDate}
                onDayChange={this.startDateChange.bind(this)}
                dayPickerProps={{
                  locale: 'au',
                  localeUtils: MomentLocaleUtils,
                  disabledDays: { after: endDate }
                }}
              />
            </Col>
            <Col xs={6}>
              <DayPickerInput
                formatDate={formatDate}
                parseDate={parseDate}
                inputProps={{ className: 'form-control' }}
                value={endDate}
                onDayChange={this.endDateChange.bind(this)}
                dayPickerProps={{
                  locale: 'au',
                  localeUtils: MomentLocaleUtils,
                  disabledDays: { before: startDate }
                }}
              />
            </Col>
            <Col xs={12}>
              <Button
                className="booking-download__button"
                bsStyle="primary"
                onClick={this.downloadBookings}
              >
                Download
              </Button>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/bookings/BookingSidebar.js